import { IconButton } from "@chakra-ui/react";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { usePersistentGrid } from "../../hooks/usePersistentGrid";

export default function PersistentGridResetButton() {
    const { reset } = usePersistentGrid();

    return (
        <IconButton icon={<FaArrowRotateLeft />} onClick={() => reset()} aria-label={"Reset"}>Reset</IconButton>
    );
}